module.exports = __webpack_public_path__ + "static/media/veSignUpBackground.2a990437.png";